import React, { useState, useEffect, useRef } from 'react';

const recentlyJoined = [
  { name: "Neha Yadav", img: "https://randomuser.me/api/portraits/women/1.jpg" },
  { name: "Khushi Patel", img: "https://randomuser.me/api/portraits/women/2.jpg" },
  { name: "Aarti Sharma", img: "https://randomuser.me/api/portraits/women/3.jpg" },
  { name: "Riya Singh", img: "https://randomuser.me/api/portraits/women/4.jpg" },
  { name: "Simran Kaur", img: "https://randomuser.me/api/portraits/women/5.jpg" },
  { name: "Priya Gupta", img: "https://randomuser.me/api/portraits/women/6.jpg" },
  { name: "Anjali Mishra", img: "https://randomuser.me/api/portraits/women/7.jpg" },
  { name: "Pooja Verma", img: "https://randomuser.me/api/portraits/women/8.jpg" },
  { name: "Divya Singh", img: "https://randomuser.me/api/portraits/women/9.jpg" },
  { name: "Shreya Joshi", img: "https://randomuser.me/api/portraits/women/10.jpg" }
];

const topCenters = [
  { name: "Rank 4 AMAN KHAN", img: "https://randomuser.me/api/portraits/men/11.jpg" },
  { name: "Rank 5 GAURAV ROHILLA", img: "https://randomuser.me/api/portraits/men/12.jpg" },
  { name: "Rank 6 RAVI KUMAR", img: "https://randomuser.me/api/portraits/men/13.jpg" },
  { name: "Rank 7 SURESH YADAV", img: "https://randomuser.me/api/portraits/men/14.jpg" },
  { name: "Rank 8 VIKAS SHARMA", img: "https://randomuser.me/api/portraits/men/15.jpg" },
  { name: "Rank 9 RAJAT VERMA", img: "https://randomuser.me/api/portraits/men/16.jpg" },
  { name: "Rank 10 ANKIT JAIN", img: "https://randomuser.me/api/portraits/men/17.jpg" },
  { name: "Rank 11 DEEPAK YADAV", img: "https://randomuser.me/api/portraits/men/18.jpg" },
  { name: "Rank 12 MANOJ SHARMA", img: "https://randomuser.me/api/portraits/men/19.jpg" },
  { name: "Rank 13 ROHIT VERMA", img: "https://randomuser.me/api/portraits/men/20.jpg" }
];

const campusImages = [
  "/assets/campus1.jpg",
  "/assets/campus2.jpg",
  "/assets/campus3.jpg",
  "/assets/campus4.jpg",
  "/assets/campus1.jpg",
];

const VerticalMarquee = ({ items, speed = 30, direction = 'up', color }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const animationRef = useRef(null);
  const positionRef = useRef(0);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return;

    const itemHeight = 80; // Increased height of each item
    const contentHeight = items.length * itemHeight;
    container.style.height = `${contentHeight}px`;

    const animate = () => {
      if (isPaused) {
        animationRef.current = requestAnimationFrame(animate);
        return;
      }

      if (direction === 'up') {
        positionRef.current -= 0.5;
        if (positionRef.current <= -contentHeight) {
          positionRef.current = 0;
        }
      } else {
        positionRef.current += 0.5;
        if (positionRef.current >= 0) {
          positionRef.current = -contentHeight;
        }
      }

      content.style.transform = `translateY(${positionRef.current}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [items, direction, isPaused]);

  return (
    <div
      ref={containerRef}
      style={{
        height: '400px',
        overflow: 'hidden',
        position: 'relative'
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        ref={contentRef}
        style={{
          position: 'absolute',
          width: '100%'
        }}
      >
        {[...items, ...items].map((item, idx) => (
          <div key={idx} style={{ 
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            padding: '12px 16px',
            borderRadius: '50px',
            transition: 'all 0.3s',
            marginBottom: '8px',
            ':hover': {
              background: color === '#8d2020' ? '#f8e8e8' : '#e3f2fd',
              transform: 'scale(1.02)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              border: `3px solid ${color}`,
              overflow: 'hidden',
              flexShrink: 0
            }}>
              <img 
                src={item.img} 
                alt={item.name} 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }} 
              />
            </div>
            <span style={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#333',
              whiteSpace: 'nowrap'
            }}>{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const HorizontalMarquee = ({ images, speed = 20 }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const animationRef = useRef(null);
  const positionRef = useRef(0);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return;

    const itemWidth = 600; // Increased width of each image
    const contentWidth = images.length * itemWidth;

    const animate = () => {
      if (isPaused) {
        animationRef.current = requestAnimationFrame(animate);
        return;
      }

      positionRef.current -= 1;
      if (positionRef.current <= -contentWidth) {
        positionRef.current = 0;
      }

      content.style.transform = `translateX(${positionRef.current}px)`;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [images, isPaused]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '16px'
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        ref={contentRef}
        style={{
          display: 'flex',
          position: 'absolute',
          height: '100%'
        }}
      >
        {[...images, ...images].map((img, idx) => (
          <div key={idx} style={{
            width: '600px',
            height: '400px',
            flexShrink: 0,
            position: 'relative'
          }}>
            <img 
              src={img} 
              alt="Campus" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '16px'
              }} 
            />
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
              color: 'white',
              padding: '24px',
              textAlign: 'center',
              fontWeight: 600,
              fontSize: '24px',
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px'
            }}>
              Our Beautiful Campus
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function Rectop() {
  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
      padding: '40px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 15px rgba(0,0,0,0.08)',
      position: 'relative',
      overflow: 'hidden',
      gap: '40px',
      flexWrap: 'wrap'
    }}>
      
      {/* Left: Recently Joined Students (vertical up marquee) */}
      <div style={{
        width: '350px',
        height: '500px',
        background: 'white',
        borderRadius: '20px',
        padding: '24px',
        boxShadow: '0 10px 30px rgba(141, 32, 32, 0.15)',
        borderTop: '6px solid #8d2020',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <h4 style={{ 
          color: '#8d2020', 
          fontWeight: 700, 
          textAlign: 'center', 
          marginBottom: '24px',
          fontSize: '22px',
          position: 'relative',
          paddingBottom: '12px'
        }}>
          Recently Joined Students
          <div style={{
            position: 'absolute',
            bottom: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            background: '#8d2020',
            borderRadius: '4px'
          }}></div>
        </h4>
        
        <VerticalMarquee 
          items={recentlyJoined} 
          direction="up" 
          speed={30} 
          color="#8d2020" 
        />
      </div>
      
      {/* Middle: Campus Images Carousel */}
      <div style={{
        width: '600px',
        height: '400px',
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        position: 'relative',
        margin: '0 20px'
      }}>
        <HorizontalMarquee images={campusImages} speed={20} />
      </div>
      
      {/* Right: Top Centers (vertical down marquee) */}
      <div style={{
        width: '350px',
        height: '500px',
        background: 'white',
        borderRadius: '20px',
        padding: '24px',
        boxShadow: '0 10px 30px rgba(25, 118, 210, 0.15)',
        borderTop: '6px solid #1976d2',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <h4 style={{ 
          color: '#1976d2', 
          fontWeight: 700, 
          textAlign: 'center', 
          marginBottom: '24px',
          fontSize: '22px',
          position: 'relative',
          paddingBottom: '12px'
        }}>
          Top Centers
          <div style={{
            position: 'absolute',
            bottom: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            background: '#1976d2',
            borderRadius: '4px'
          }}></div>
        </h4>
        
        <VerticalMarquee 
          items={topCenters} 
          direction="down" 
          speed={30} 
          color="#1976d2" 
        />
      </div>
    </div>
  );
}